const privacyPolicySl = {
  breadcrumbs: { home: 'මුල් පිටුව', title: 'පෞද්ගලිකත්ව ප්‍රතිපත්තිය' },
  hero: {
    title: 'අපගේ පෞද්ගලිකත්වයට අප වගකිව යුතුයි',
    subtitle: 'ඔබගේ දත්ත ආරක්ෂාව, පැහැදිලි බව සහ පාලන අයිතිය — අපගේ ප්‍රධාන කාරණා'
  },
  principles: [
    { title: 'ආරක්ෂාව', description: 'අදියරයන් ගොඩක් සහිත ආරක්ෂක ක්‍රමවේද — එන්ක්‍රිප්ෂන් සහ ප්‍රවේශ පාලනය' },
    { title: 'පැහැදිලි බව', description: 'ඔබගේ දත්ත කෙසේ භාවිතා කරන්නේදැයි පැහැදිලිව දන්වන්නෙමු' },
    { title: 'පාලන අයිතිය', description: 'ඔබට ඔබේ දත්ත බලන්න, සංස්කරණය කරන්න, මකා දැමිය හැක' },
    { title: 'පොරොන්දු', description: 'නීති, ප්‍රමිතීන් සහ ක්‍රියා පටිපාටි සමඟ අනුකූලතාව' }
  ],
  dataTitle: 'අපි සංග්‍රහ කරන දත්ත',
  dataTypes: [
    { category: 'පැතිකඩ තොරතුරු', items: ['නම', 'ඊමේල්', 'දුරකථන', 'රහස්පදය'], purpose: 'ගිණුම පවත්වාගෙන යාම' },
    { category: 'පිහිටුම', items: ['දිස්ත්‍රික්කය', 'උපසිලාව', 'බසාර්'], purpose: 'ස්ථානය අනුව සේවාව' },
    { category: 'ගෙවීම්', items: ['ට්‍රාන්සැක්ෂන්', 'ගෙවීම් තත්ත්වය'], purpose: 'ඇණවුම් සැකසීම' },
    { category: 'සංවැදීම', items: ['ඩිවයිස්', 'බ්‍රවුසර්', 'IP'], purpose: 'සුරක්ෂිත බව සහ දක්‍ෂතාව' }
  ],
  usage: {
    title: 'දත්ත භාවිතය',
    primaryTitle: 'අපි දත්ත භාවිතා කරන්නේ',
    primary: ['ඇණවුම් සැකසීම', 'සේවා සැපයීම', 'පාරිභෝගික සහාය', 'නීති අනුකූලත්වය'],
    improveTitle: 'මෙම දත්තෙන් අපි වැඩි දියුණු කරන්නේ',
    improve: ['තෝරාගැනීම් තේරුම්ගැනීම', 'ක්‍රියාකාරිත්වය', 'ආරක්ෂාව', 'අත්දැකීම']
  },
  rights: {
    title: 'ඔබගේ අයිතිවාසිකම්',
    items: [
      { right: 'දත්ත දර්ශනය', description: 'අප හා ඇති ඔබගේ දත්ත බලන්න' },
      { right: 'සංස්කරණය', description: 'වලංගු නැති දත්ත යාවත්කාලීන කරන්න' },
      { right: 'මකා දැමීම', description: 'අවශ්‍ය නම් ඔබගේ දත්ත ඉවත් කරන්න' },
      { right: 'බාගත', description: 'ඔබගේ දත්ත පිටපත් බාගත කරන්න' }
    ]
  },
  security: {
    title: 'ආරක්ෂක ක්‍රියාමාර්ග',
    intro: 'අපි දත්ත ආරක්ෂා සඳහා කඩිනම් ක්‍රියාමාර්ග ගන්නෙමු:',
    measures: ['TLS/HTTPS', 'දත්ත එන්ක්‍රිප්ෂන්', 'ප්‍රවේශ පාලනය', 'මෙවලම් හා ක්‍රියාකාරකම් ලිඛිත කිරීම', 'නිතර පරීක්ෂණ']
  },
  cookies: {
    title: 'කුකීස් ප්‍රතිපත්තිය',
    usageTitle: 'කුකීස් භාවිතය',
    p1: 'අපි කුකීස් භාවිතා කරන්නේ පරිශීලක අත්දැකීම වඩාත් හොඳ කිරීම සඳහාය.',
    p2: 'ඔබට බ්‍රවුසර සැකසුම් හරහා කුකීස් පාලනය කළ හැක.'
  },
  sharing: {
    title: 'තෙවන පාර්ශ්වයට බෙදා හදා ගැනීම',
    intro: 'අනුමත සහකරුවන් සමඟ පමණක් සීමිත දත්ත බෙදා හදමු.',
    authorizedTitle: 'අනුමත බෙදාහැරීම්',
    authorized: ['ගෙවීම් සැකසීම', 'විතරකරණ සහ ඵලිතාක්ෂණ', 'විතරකරණ හා ප්‍රවාහනය'],
    notDoTitle: 'අප නොකරන දේ',
    notDo: ['අනුමතිය නොමැතිව විකුණනේ නැත', 'අනවශ්‍ය ප්‍රවේශය', 'අනවශ්‍ය සංවේදී දත්ත රඳවා ගැනීම']
  },
  retention: {
    title: 'දත්ත තබා ගැනීම',
    retentionTitle: 'තබා ගැනීමේ කාලය',
    retentionText: 'නීති හා සේවා අවශ්‍යතාවයන්ට අනුව දත්ත තබා ගන්නෙමු.',
    deleteTitle: 'මකා දැමීම් ප්‍රතිපත්තිය',
    deleteText: 'අවශ්‍ය නම් ඔබගේ දත්ත ඉවත් කරනු ලැබේ.'
  },
  updates: {
    title: 'ප්‍රතිපත්තිය යාවත්කාලීන කිරීම',
    alert: 'අපි අවස්ථාවක් දීමින් මෙය යාවත්කාලීන කරනු ඇත.',
    notify: 'වැදගත් වෙනස්කම් පිළිබඳව ඔබට දැනුම් දෙනු ඇත.',
    lastUpdatedPrefix: 'අවසන් යාවත්කාලීන කිරීම:',
    lastUpdatedDate: '২০২৫-০৩-১৫'
  },
  contact: {
    title: 'පෞද්ගලිකත්ව සම්බන්ධයෙන් සම්බන්ධ වන්න',
    subtitle: 'ඔබට ප්‍රශ්න තිබේ නම් අපව සම්බන්ධ වන්න',
    button: 'අපව අමතන්න',
    email: 'privacy@grameenbazar.com'
  }
};

export default privacyPolicySl;


